import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Building2, ChevronRight, Code2, Inbox, ListOrdered, Palette, Plug, Plus, Shield, Star, User, Users } from 'lucide-react';
import { applyWorkspaceShelf } from '@unitly/contracts';
import { useWorkspaces, useWorkspaceShelf } from '../api/queries.ts';
import { useOrgCtx } from '../app/org-context.tsx';
import { PageHeader } from '../features/shell/Chrome.tsx';
import { WorkspaceShelfSheet } from '../features/shell/WorkspaceShelfSheet.tsx';
import { WorkspaceAvatar } from '../ui/primitives.tsx';

export const SETTINGS_LINKS = [
  { id: 'profile', label: 'Profilo e notifiche', icon: User, color: 'var(--ws-blue)' },
  { id: 'appearance', label: 'Aspetto', icon: Palette, color: 'var(--ws-purple)' },
  { id: 'security', label: 'Sicurezza e dispositivi', icon: Shield, color: 'var(--ws-green)' },
  { id: 'integrations', label: 'Integrazioni', icon: Plug, color: 'var(--ws-teal)' },
  { id: 'organization', label: 'Organizzazione', icon: Building2, color: 'var(--ws-orange)', admin: true },
  { id: 'members', label: 'Membri e inviti', icon: Users, color: 'var(--ws-pink)' },
  { id: 'developer', label: 'API e webhook', icon: Code2, color: 'var(--ws-indigo)', admin: true },
] as const;

/** Mobile "Altro": spazi e accesso rapido all'inbox. Il profilo/account vive nell'icona in alto a destra. */
export function MenuPage() {
  const { base, orgId, detail, openCreateWorkspace } = useOrgCtx();
  const workspaces = useWorkspaces(orgId);
  const shelf = useWorkspaceShelf(orgId);
  const [organizing, setOrganizing] = useState(false);
  const ordered = workspaces.data && shelf.data ? applyWorkspaceShelf(workspaces.data, shelf.data) : workspaces.data;

  return (
    <div className="page wide">
      <PageHeader title="Altro" />

      <div className="card list" style={{ marginBottom: 26 }}>
        <Link to={`${base}/inbox`} className="list-row">
          <span className="list-icon" style={{ background: 'var(--ws-red)' }}><Inbox size={17} /></span>
          <span className="grow">Inbox</span>
          <ChevronRight className="chev" size={20} />
        </Link>
      </div>

      <section className="section">
        <div className="section-head">
          <h2 className="section-title">Spazi</h2>
          <span style={{ display: 'flex', gap: 4 }}>
            {(workspaces.data?.length ?? 0) > 1 && (
              <button type="button" className="btn btn-plain btn-sm" onClick={() => setOrganizing(true)}><ListOrdered size={16} /> Organizza</button>
            )}
            {detail?.capabilities.createWorkspace && (
              <button type="button" className="btn btn-plain btn-sm" onClick={openCreateWorkspace}><Plus size={16} /> Nuovo</button>
            )}
          </span>
        </div>
        <div className="card list">
          {ordered?.map((w) => (
            <Link key={w.id} to={`${base}/w/${w.key}`} className="list-row">
              <WorkspaceAvatar name={w.name} keyLabel={w.key} color={w.color} logoUrl={w.logoUrl} active={w.myAttentionTasks > 0} size={40} />
              <span className="grow">
                <div>{w.name}{shelf.data?.pinned.includes(w.id) && <Star size={13} style={{ marginLeft: 6, verticalAlign: -1 }} fill="var(--yellow)" color="var(--yellow)" />}</div>
                <div className="secondary">{w.openTasks} task aperte{w.myOpenTasks ? ` · ${w.myOpenTasks} tue` : ''}</div>
              </span>
              <ChevronRight className="chev" size={20} />
            </Link>
          ))}
          {workspaces.data?.length === 0 && <p className="hint" style={{ padding: 16, margin: 0 }}>Nessuno spazio ancora.</p>}
        </div>
      </section>
      {workspaces.data && <WorkspaceShelfSheet open={organizing} onClose={() => setOrganizing(false)} workspaces={workspaces.data} />}
    </div>
  );
}
